import { MUIChip } from "@abb/arcadia-ui-react"
import type { ComponentProps } from "react"
import { RoleRequestStatusEnum } from "../models/RoleRequest"

type ChipProps = ComponentProps<typeof MUIChip>

export function getRoleRequestStatusProps(status: RoleRequestStatusEnum): ChipProps {
  let props: ChipProps = {
    label: `${RoleRequestStatusEnum[status]}`,
    size: 32,
  }

  switch (status) {
    case RoleRequestStatusEnum.Open:
      props = {
        ...props,
        label: "Pending",
        leadingIconName: "icon_abb_dias icon-abb_time-clock",
      }
      break
    case RoleRequestStatusEnum.Closed:
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_completed-check" }
      break
    default:
      break
  }

  return props
}
